/*
 * @Author: Wangchaoke
 * @Date: 2020-02-12 13:48:00
 * @LastEditTime : 2020-02-13 09:29:30
 * @LastEditors  : Please set LastEditors
 * @Description: DonatewxConfig 用于亿起抗疫活动微信分享
 * @FilePath: /xingmahui_front/src/assets/js/DonatewxConfig.js
 */
import {is_weixin,getCookie} from '@/assets/js/common.js'
import wx from 'weixin-js-sdk'

export default{
    // 微信调取相册方法
    getAlbum:function(obj,calback){
        var that=this;
        if(is_weixin()){
            obj.$http.get('/wechat/oauth2/getJSSDKConfig?url='+encodeURIComponent(location.href.split('#')[0]),{},res=>{
                wx.config({
                    debug: false,
                    appId: res.appId,
                    timestamp: res.timestamp,
                    nonceStr: res.nonceStr,
                    signature:res.signature,
                    jsApiList: [
                        'checkJsApi',
                        // 'onMenuShareTimeline', // 分享到朋友圈接口
                        // 'onMenuShareAppMessage', //  分享到朋友接口
                        'chooseImage',//调取微信相册接口
                        'getLocalImgData',
                        'uploadImage'
                    ],
                    openTagList: ["wx-open-launch-weapp"]
                });
                wx.ready(function () {
                    // 微信分享的数据
                    setTimeout(function(){
                        wx.chooseImage({
                            count: 1, // 默认9
                            sizeType: ['original','compressed'], // 可以指定是原图还是压缩图，默认二者都有
                            sourceType: ['album'], // 可以指定来源是相册还是相机，默认二者都有
                            success: function (res) {
                                var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                                    wx.uploadImage({
                                        localId: localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
                                        isShowProgressTips: 1, // 默认为1，显示进度提示
                                        success: function (result) {
                                            let serverId = result.serverId; // 返回图片的服务器端ID
                                            if(result.errMsg === "uploadImage:ok"){
                                                calback([serverId,localIds]);
                                            }
                                            // wx.downloadImage({
                                            //     serverId: serverId, // 需要上传的图片的本地ID，由chooseImage接口获得
                                            //     isShowProgressTips: 1, // 默认为1，显示进度提示
                                            //     success: function (result) {
                                            //         let localId = result.localId; // 返回图片的服务器端ID
                                            //         alert(localId)
                                            //         // 可以将serverId传给后台，用于存放在自己服务器上
                                            //     }
                                            // })
                                            // 可以将serverId传给后台，用于存放在自己服务器上
                                        },
                                        complete: function(result) {
                                        },
                                        fail: function (res) {
                                            calback('err');
                                        }
                                    });
                            },
                            fail: function (res) {
                                alert(JSON.stringify(res));
                                calback('err');
                            }
                        });
                    },600)
                })
            })
        }
    },
    wxShare:function(obj,shareDataParams){
        if(is_weixin()){
            obj.$http.get('/wechat/oauth2/getJSSDKConfig?url='+encodeURIComponent(location.href.split('#')[0]),{},res=>{
                wx.config({
                    debug: false,
                    appId: res.appId,
                    timestamp: res.timestamp,
                    nonceStr: res.nonceStr,
                    signature:res.signature,
                    openTagList: ["wx-open-launch-weapp"],
                    jsApiList: [
                        'checkJsApi',
                        'updateAppMessageShareData',
                        'updateTimelineShareData',
                        'onMenuShareTimeline', // 分享到朋友圈接口
                        'onMenuShareAppMessage' //  分享到朋友接口
                    ],

                });
                wx.ready(function () {
                    // 微信分享的数据
                    var shareData = {
                        link: shareDataParams.shareLink,
                        desc: shareDataParams.shareDesc,
                        title: shareDataParams.shareTitle,
                        imgUrl: shareDataParams.imgUrl,
                        success: function () {
                            shareDataParams.shareSuccess();
                        }
                    }
                    wx.onMenuShareTimeline(shareData);//分享到朋友圈
                    wx.onMenuShareAppMessage(shareData);//分享给朋友
                    wx.updateAppMessageShareData(shareData);//分享给朋友和分享到QQ
                    wx.updateTimelineShareData(shareData);//分享到朋友圈和分享到QQ空间
                })
            })
        }
    }
}